import {
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import logoImage from "../assets/logo.jpg";
import { MenuItem } from "./MenuItem";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

type DesktopNavBarProps = {
  menuItems: Array<MenuItem>;
};

const DesktopNavBar = (props: DesktopNavBarProps) => {
  const { menuItems } = props;
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <Grid
      container
      alignItems={"center"}
      sx={{
        position: "sticky",
        zIndex: "1000",
        top: "0",
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <Grid item xs={2}>
        <Link
          to={"home"}
          spy={true}
          smooth={true}
          offset={-64}
          duration={500}
          key={"homeButton"}
        >
          <Button
            className="TextButton"
            onClick={() => {
              navigate("/");
              scrollToTop();
            }}
            sx={{ textTransform: "initial", padding: "0" }}
          >
            <Typography
              variant="h5"
              sx={{ display: "flex", fontWeight: "700" }}
            >
              <img src={logoImage} alt="Logo" style={{ width: 36, height: 36, borderRadius: "50%", marginRight: 8 }} />
              Ryan Dean
            </Typography>
          </Button>
        </Link>
      </Grid>
      <Grid item xs={9}>
        <Box
          sx={{
            height: "50px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          {menuItems.map((item) => (
            <Link
              to={item.Path.split(" ").join("")}
              spy={true}
              smooth={true}
              offset={-64}
              duration={500}
              key={item.Text}
            >
              <Button
                className="TextButton"
                onClick={() =>
                  navigate("/", { state: { targetId: item.Path } })
                }
                sx={{
                  minHeight: "48px",
                  pt: 0,
                  pb: 0,
                  "&.Mui-selected": {
                    fontWeight: "700",
                  },
                  overflow: "visible",
                  textTransform: "initial",
                  padding: "10px",
                  marginLeft: "20px",
                }}
              >
                {item.Text}
              </Button>
            </Link>
          ))}

          <a href={"/cv"} rel="noreferrer">
            <Button
              className="TextButton"
              sx={{
                minHeight: "48px",
                pt: 0,
                pb: 0,
                "&.Mui-selected": {
                  fontWeight: "700",
                },
                overflow: "visible",
                textTransform: "initial",
                padding: "10px",
                marginLeft: "20px",
              }}
            >
              CV
            </Button>
          </a>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DesktopNavBar;
